import { createModule } from '@/myops/core'

const state = {
  modelType: '',// 模型名称
  chatSessionId: '',
  SHOW_SATIS_EID: [],
}

const getters = {
  chatSessionId(state, getters, rootState) {
    return state.chatSessionId
  },
  modelType(state) {
    return state.modelType
  },
  showSatisEid(state) {
    return state.SHOW_SATIS_EID
  },
}

const mutations = {
  SET_MODEL_TYPE(state, modelType) {
    state.modelType = modelType
  },
  SET_CHAT_SESSION_ID(state, chatSessionId) {
    state.chatSessionId = chatSessionId
  },
  SET_SHOW_SATIS_EID(state, SHOW_SATIS_EID) {
    state.SHOW_SATIS_EID = SHOW_SATIS_EID
  },
}

const actions = {}
export default createModule({ namespaced: true, state, getters, mutations, actions })
